import { PageMasterMode, usePageContext } from "./PageContext";
import { SessionMode } from "../../contexts/appStore/hooks";
import { GoTo } from "./GoTo";

/**
 * Tiny redirect route mounted at `/j/:shortId`.
 *
 * The QR code shown in the lobby points at this short URL so that flyers,
 * displays, and shared links stay short. We forward to the regular lobby
 * route, which already resolves shortIds via `meeting.getById`.
 */
export const JoinShortIdRedirect = () => {
  const pageContext = usePageContext<SessionMode.MASTER>();
  const shortId = pageContext?.params?.id;
  if (!shortId) {
    return <GoTo page={PageMasterMode.LIST} />;
  }
  return <GoTo page={PageMasterMode.LOBBY} params={{ id: shortId }} options={{ queries: { provider: undefined }, replace: true }} />;
};
